import api from './api';

export const storeService = {
  // Authentication
  sendOTP: async (phone: string) => {
    const response = await api.post('/api/otp/send', { phoneNumber: phone });
    return response.data;
  },

  verifyOTP: async (phone: string, otp: string) => {
    const response = await api.post('/api/otp/verify', { phoneNumber: phone, otp });
    return response.data;
  },

  // Store login (separate from OTP, uses store credentials)
  storeLogin: async (phone: string, otp: string) => {
    const response = await api.post('/api/stores/login', { phone, otp });
    return response.data;
  },

  // Register new store
  registerStore: async (storeData: any) => {
    const response = await api.post('/api/stores', storeData);
    return response.data;
  },

  // Get store details
  getStoreDetails: async (storeId: string) => {
    const response = await api.get(`/api/stores/${storeId}`);
    return response.data;
  },

  // Update store status (open/closed)
  updateStoreStatus: async (storeId: string, isOpen: boolean) => {
    const response = await api.patch(`/api/stores/${storeId}/status`, { isOpen });
    return response.data;
  },

  // Get store orders
  getStoreOrders: async (storeId: string, status?: string) => {
    const response = await api.get(`/api/stores/${storeId}/orders`, {
      params: { status }
    });
    return response.data;
  },

  // Update order status
  updateOrderStatus: async (orderId: string, status: string, preparationTime?: number) => {
    const response = await api.patch(`/api/orders/${orderId}/status`, {
      status,
      preparationTime
    });
    return response.data;
  },

  // Accept order
  acceptOrder: async (orderId: string, preparationTime: number) => {
    const response = await api.post(`/api/orders/${orderId}/accept`, {
      preparationTime
    });
    return response.data;
  },

  // Reject order
  rejectOrder: async (orderId: string, reason: string) => {
    const response = await api.post(`/api/orders/${orderId}/reject`, {
      reason
    });
    return response.data;
  },

  // Get store items
  getStoreItems: async (storeId: string) => {
    const response = await api.get(`/api/stores/${storeId}/items`);
    return response.data;
  },

  // Add item
  addItem: async (storeId: string, itemData: any) => {
    const response = await api.post(`/api/stores/${storeId}/items`, itemData);
    return response.data;
  },

  // Update item
  updateItem: async (itemId: string, itemData: any) => {
    const response = await api.patch(`/api/items/${itemId}`, itemData);
    return response.data;
  },

  // Delete item
  deleteItem: async (itemId: string) => {
    const response = await api.delete(`/api/items/${itemId}`);
    return response.data;
  },

  // Toggle item availability
  toggleItemAvailability: async (itemId: string, available: boolean) => {
    const response = await api.patch(`/api/items/${itemId}/availability`, {
      available
    });
    return response.data;
  },

  // Menu management (new API for menuItems)
  getStoreMenu: async (storeId: string) => {
    const response = await api.get(`/api/stores/${storeId}/menu`);
    return response.data;
  },

  addMenuItem: async (storeId: string, menuItem: any) => {
    const response = await api.post(`/api/stores/${storeId}/menu`, menuItem);
    return response.data;
  },

  updateMenuItem: async (storeId: string, itemId: string, menuItem: any) => {
    const response = await api.put(`/api/stores/${storeId}/menu/${itemId}`, menuItem);
    return response.data;
  },

  deleteMenuItem: async (storeId: string, itemId: string) => {
    const response = await api.delete(`/api/stores/${storeId}/menu/${itemId}`);
    return response.data;
  },

  // Get store earnings
  getStoreEarnings: async (storeId: string, period?: string) => {
    const response = await api.get(`/api/stores/${storeId}/earnings`, {
      params: { period }
    });
    return response.data;
  },

  // Update store settings
  updateStoreSettings: async (storeId: string, settings: any) => {
    const response = await api.patch(`/api/stores/${storeId}/settings`, settings);
    return response.data;
  },

  // Custom order - Send bill to customer
  sendCustomBill: async (orderId: string, billData: any) => {
    const response = await api.post(`/api/orders/${orderId}/custom-bill`, billData);
    return response.data;
  },

  // Custom order - Get chat messages
  getOrderMessages: async (orderId: string) => {
    const response = await api.get(`/api/orders/${orderId}/messages`);
    return response.data;
  },

  // Custom order - Send message
  sendOrderMessage: async (orderId: string, text: string) => {
    const response = await api.post(`/api/orders/${orderId}/message`, { 
      sender: 'Store',
      text 
    });
    return response.data;
  },
};

export default storeService;
